import Firmware from './Firmware';
import OBUUidLookup from './UidLookup';
import OBUOperatorManagement from './OperatorManagement';
import OBUMspNoticeEditor from './MspNoticeEditor';
import OBURmaDelete from './RmaDelete';
import OBUChangeLog from './ChangeLog';
import OBUNoticeEditor from './NoticeEditor';
import OBUUserProfile from './UserProfile';

import AdminContentLayout from '../components/Layout';


export default {
    OBUFirmware: ({ title, PathList }) => <AdminContentLayout title={title} PathList={PathList}><Firmware /></AdminContentLayout>,
    OBUOperatorManagement: ({ title, PathList }) => <AdminContentLayout title={title} PathList={PathList}><OBUOperatorManagement /></AdminContentLayout>,
    OBUUidLookup: ({ title, PathList }) => <AdminContentLayout title={title} PathList={PathList}><OBUUidLookup /></AdminContentLayout>,
    OBUMspNoticeEditor: ({ title, PathList }) => <AdminContentLayout title={title} PathList={PathList}><OBUMspNoticeEditor /></AdminContentLayout>,
    OBURmaDelete: ({ title, PathList }) => <AdminContentLayout title={title} PathList={PathList}><OBURmaDelete /></AdminContentLayout>,
    OBUChangeLog: ({ title, PathList }) => <AdminContentLayout title={title} PathList={PathList}><OBUChangeLog /></AdminContentLayout>,
    OBUNoticeEditor: ({ title, PathList }) => <AdminContentLayout title={title} PathList={PathList}><OBUNoticeEditor /></AdminContentLayout>,
    OBUUserProfile: ({ title, PathList }) => <AdminContentLayout title={title} PathList={PathList}><OBUUserProfile /></AdminContentLayout>,
}